import {createTheme, fade} from '@material-ui/core/styles';

export const buildUserTableTheme = (theme) => {
    const isDark = theme.palette.type === 'dark';
    const line = fade(theme.palette.text.primary, 0.12);
    const line2 = fade(theme.palette.text.primary, isDark ? 0.08 : 0.07);
    const head = fade(theme.palette.text.primary, isDark ? 0.03 : 0.02);
    return createTheme({
        ...theme,
        overrides: {
            ...(theme.overrides || {}),
            MUIDataTable: {
                paper: {
                    borderRadius: 16,
                    border: `1px solid ${line2}`,
                    boxShadow: isDark ? '0 1px 3px rgba(0,0,0,0.3)' : '0 1px 3px rgba(0,0,0,0.04)',
                    overflow: 'hidden',
                    backgroundColor: theme.palette.background.paper
                },
                responsiveScrollFullHeight: {
                    overflowX: 'auto',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                    '&::-webkit-scrollbar': {
                        display: 'none'
                    }
                }
            },
            MuiTableCell: {
                head: {
                    height: 44,
                    padding: '0 16px',
                    fontSize: 11,
                    fontWeight: 700,
                    letterSpacing: '0.08em',
                    textTransform: 'uppercase',
                    whiteSpace: 'nowrap',
                    color: theme.palette.text.secondary,
                    backgroundColor: head,
                    borderBottom: `1px solid ${line}`
                },
                body: {
                    height: 48,
                    padding: '0 16px',
                    fontSize: 13,
                    color: theme.palette.text.primary,
                    borderBottom: `1px solid ${line2}`
                },
                sizeSmall: {
                    padding: '0 16px',
                    '&:last-child': {
                        paddingRight: 12
                    }
                }
            },
            MUIDataTableHeadCell: {
                fixedHeader: {
                    backgroundColor: head
                },
                sortAction: {
                    alignItems: 'center'
                },
                sortActive: {
                    color: theme.palette.text.primary
                },
                sortLabelRoot: {
                    height: 'auto'
                }
            },
            MuiTableSortLabel: {
                root: {
                    '&:hover': {
                        color: theme.palette.text.primary
                    }
                },
                active: {
                    '& $icon': {
                        color: isDark ? theme.palette.primary.main : '#8a8200'
                    }
                },
                icon: {
                    fontSize: 14,
                    marginLeft: 2
                }
            },
            MUIDataTableBodyRow: {
                root: {
                    cursor: 'pointer',
                    transition: theme.transitions.create('background-color', {duration: 120}),
                    '&:focus-visible': {
                        outline: `2px solid ${theme.palette.primary.main}`,
                        outlineOffset: -2
                    }
                }
            },
            MUIDataTableBody: {
                emptyTitle: {
                    padding: '40px 24px 48px'
                }
            },
            MuiTablePagination: {
                toolbar: {
                    minHeight: 52,
                    fontSize: 13,
                    color: theme.palette.text.secondary
                },
                caption: {
                    fontSize: 13
                },
                select: {
                    fontSize: 13,
                    fontWeight: 500,
                    color: theme.palette.text.primary
                },
                actions: {
                    marginLeft: 12
                }
            },
            MUIDataTablePagination: {
                root: {
                    '&:last-child': {
                        padding: '0 12px 0 16px',
                        borderBottom: 0
                    }
                }
            }
        }
    });
};
